"use client";

import { useContext } from "react";
import {
  TestScopeContext,
  type TestScopeKontext,
  inaktiverTestScope,
} from "./test-scope-context.ts";

export type { TestScopeKontext };

export function useTestScope(): TestScopeKontext {
  const ctx = useContext(TestScopeContext);
  return ctx ?? inaktiverTestScope;
}
